import React from "react"
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material"
import { Product } from "@/shared/types/product"

interface Props {
  open: boolean
  product: Product | null
  deleting: boolean
  onClose: () => void
  onConfirm: () => void
}

const DeleteProductDialog: React.FC<Props> = ({ open, product, deleting, onClose, onConfirm }) => (
  <Dialog open={open} onClose={onClose}>
    <DialogTitle>Delete Listing</DialogTitle>
    <DialogContent>
      <DialogContentText>
        Are you sure you want to delete <strong>{product?.name || "this listing"}</strong>? This action cannot be
        undone.
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} disabled={deleting}>
        Cancel
      </Button>
      <Button onClick={onConfirm} color="error" variant="contained" disabled={deleting}>
        {deleting ? "Deleting…" : "Yes, Delete"}
      </Button>
    </DialogActions>
  </Dialog>
)

export default DeleteProductDialog
